import "./bootstrap";
import store from "./store"; // Vuex store
import.meta.glob(["../images/**", "../fonts/**"]);
import { createApp } from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";

//Import Components
import NavigationAdmin from "./components/elements/PageContentNavElement.vue";
import Media from "./components/admin/MediaComponent.vue";
import Content from "./components/admin/ContentDefaultComponent.vue";
import AdminHome from "./components/admin/HomeComponent.vue";
import Pages from "./components/admin/PagesComponent.vue";
import PagesContent from "./components/admin/PagesContentComponent.vue";
import Navigation from "./components/admin/NavComponent.vue";
import Blog from "./components/admin/BlogComponent.vue";
import Contacts from "./components/admin/ContactsComponent.vue";
import Workwithus from "./components/admin/WorkwithusComponent.vue";
import Feed from "./components/admin/FeedComponent.vue";
import StoresToken from "./components/admin/StoresTokenComponent.vue";
import User from "./components/admin/UserAdmin.vue";
import UserRoutine from "./components/admin/UserRoutine.vue";
import BlogCategory from "./components/admin/BlogCategoryAdmin.vue";
import BlogRoutine from "./components/admin/BlogCategoryRoutine.vue";
import ProfessionalCreate from "./components/website/core/ProfessionalCreate.vue";
import ContractAdmin from "./components/admin/core/ContractAdmin.vue";
import ProfessionalContract from "./components/admin/core/professional/Contract.vue";
import LocationAdmin from "./components/admin/core/LocationAdmin.vue";
import LocationRoutine from "./components/admin/core/LocationRoutine.vue";
import AccessorieAdmin from "./components/admin/core/AccessorieAdmin.vue";
import AccessorieRoutine from "./components/admin/core/AccessorieRoutine.vue";
import OfficesAdmin from "./components/admin/core/OfficesAdmin.vue";
import OfficesRoutine from "./components/admin/core/OfficesRoutine.vue";
import Plp from "./components/website/core/PLP.vue";
import Pdp from "./components/website/core/PDP.vue";
import Checkout from "./components/website/core/Checkout.vue";
import ProfessionalBooking from "./components/admin/core/professional/Booking.vue";
import Test from "./components/website/core/Test.vue";
import BookingAdmin from "./components/admin/core/BookingAdmin.vue";
import ProfessionalSettings from "./components/admin/core/professional/Settings.vue";
import ContactComponent from "./components/website/ContactComponent.vue";
import ManageBookingAdmin from "./components/admin/core/ManageBookingAdmin.vue";
import HomeAdmin from "./components/admin/core/HomeAdmin.vue";
import SettingsAdmnin from "./components/admin/manage/Settings.vue";
import AccountAdmin from "./components/admin/manage/Account.vue";
import HomeDeveloper from "./components/admin/core/HomeDeveloper.vue";

//Create App
const app = createApp({});

//Components
app.component("pagecontentnav-component", NavigationAdmin);
app.component("media-component", Media);
app.component("content-component", Content);
app.component("admin-component", AdminHome);
app.component("pages-component", Pages);
app.component("pagescontent-component", PagesContent);
app.component("navigation-component", Navigation);
app.component("blog-component", Blog);
app.component("contacts-component", Contacts);
app.component("workwithus-component", Workwithus);
app.component("feed-component", Feed);
app.component("storestoken-component", StoresToken);
app.component("user-admin", User);
app.component("userroutine-admin", UserRoutine);
app.component("blogcategory-admin", BlogCategory);
app.component("blogcategoryroutine-admin", BlogRoutine);
app.component("professional-create", ProfessionalCreate);
app.component("contract-admin", ContractAdmin);
app.component("professional-contract", ProfessionalContract);
app.component("location-admin", LocationAdmin);
app.component("location-routine", LocationRoutine);
app.component("accessorie-admin", AccessorieAdmin);
app.component("accessorie-routine", AccessorieRoutine);
app.component("offices-admin", OfficesAdmin);
app.component("offices-routine", OfficesRoutine);
app.component("plp", Plp);
app.component("pdp", Pdp);
app.component("checkout", Checkout);
app.component("booking", ProfessionalBooking);
app.component("test", Test);
app.component("booking-admin", BookingAdmin);
app.component("professional-settings", ProfessionalSettings);
app.component("contact", ContactComponent);
app.component("manage-booking", ManageBookingAdmin);
app.component("home-admin", HomeAdmin);
app.component("settings-admin", SettingsAdmnin);
app.component("account-admin", AccountAdmin);
app.component("home-developer", HomeDeveloper);

//Check Route
const HREF = window.location.pathname;

app.use(VueReCaptcha, {
    siteKey: "6LdSM90rAAAAAKAzYcUD4f3gdXYiCKzZtZhCouFM", // coloque no .env do Vue
    loaderOptions: { autoHideBadge: true },
});

//Mounted App
const mountedApp = HREF.split("/").includes("admin")
    ? app.mount("#appadmin")
    : app.mount("#app");

// Use the store
app.use(store);

// Use Ckeditor
//app.use(CKEditor);
